

































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import BaseDivider from '@front-app/components/layouts/BaseDivider.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import TermsCard from '@front-app/components/cards/TermsCard.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { GroupAuditAction } from '@front-app/services/ActionApi/GroupAuditActionModel';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { required } from '@front-app/components/form/validation/validators';
import { Size } from '@front-app/components/constants';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { useGroupMemberStateChange } from '@front-app/modules/group/hooks/useGroupMemberStateChange';
import { v } from '@front-app/components/form/validation/useValidation';

export default defineComponent({
	components: {
		BaseDivider,
		CtaButton,
		ErrorCard,
		FormError,
		FormInput,
		FormLabel,
		FormSection,
		PaddedContent,
		TermsCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
		inviteId: {
			type: String,
			default: '',
		},
		sharePersonalInformationRequired: Boolean,
		accessCodeRequired: Boolean,
	},
	setup(props) {
		const trackTermsView = () => {
			trackGroupSimpleAction(props.group.id, GroupAuditAction.VIEW_GROUP_TERMS);
		};
		onMounted(trackTermsView);

		// Share personal information
		const hasAgreedToSharePersonalInformation = ref(false);
		const sharePersonalInformationAgreementPending = computed(() => {
			if (props.sharePersonalInformationRequired) {
				return !hasAgreedToSharePersonalInformation.value;
			}
			return false;
		});
		const communityName = computed(() => {
			if (props.group.community?.name) {
				return props.group.community?.name;
			}
			// We return 1 if there is no community for the group for i18n purposes
			return 1;
		});

		// Access code
		const accessCode = ref('');
		const validation = v({
			accessCode: {
				value: accessCode,
				rules: [required()],
			},
		});
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '#terms-and-access-code-form' });

		// Submit
		const {
			request: requestStateChange,
			isChangingState: isJoiningGroup,
			isErrorJoining,
		} = useGroupMemberStateChange();
		const acceptTerms = () => {
			if (!props.group) {
				return;
			}

			if (props.accessCodeRequired) {
				validation.validate();
				if (!validation.isValid.value) {
					focusFirstInvalid();
					return;
				}

				requestStateChange(props.group.id, GroupRoleRequest.CODE_AND_TERMS, props.inviteId, accessCode.value);
			} else {
				requestStateChange(props.group.id, GroupRoleRequest.TERMS, props.inviteId);
			}
		};

		return {
			// Share personal information
			hasAgreedToSharePersonalInformation,
			sharePersonalInformationAgreementPending,
			communityName,
			// Access code
			accessCode,
			validation,
			// Submit
			isErrorJoining,
			isJoiningGroup,
			acceptTerms,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
